import { Integrations } from "@sentry/browser";
import * as Sentry from "@sentry/node";
import { Options, Scope } from "@sentry/types";
import { getConfig } from "../../../config/app";
import { getAppEnv, isProdEnv } from "../../utils/env";

const isServer = typeof window === "undefined";

const baseConfig = {
  dsn: getConfig("sentry.dsn"),
  enabled: getConfig("sentry.enabled"),
  environment: getAppEnv(),
  release: process.env.WEBPACK_BUILD_ID
};

const getBrowserConfig = () => {
  if (!isServer) {
    return {
      integrations: [
        new Integrations.Breadcrumbs({
          console: isProdEnv
        })
      ]
    };
  }
  return {};
};

const getSentryConfig = (): Partial<Options> => {
  return { ...baseConfig, ...getBrowserConfig() };
};

const initSentry = () => {
  const config: Partial<Options> = getSentryConfig();
  Sentry.init(config);

  Sentry.configureScope((scope: Scope) => {
    scope.setTag("ssr", String(isServer));
  });
};

initSentry();

export { Sentry };
